/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum FunKey {
  fomo = 'fomo',
  new_user = 'newuser_packet_guide',
  new_user_gp = 'newuser_packet_gp',
  new_user_ls = 'newuser_packet_ls',
}

export const FunKeyNum = {
  [FunKey.fomo]: 4,
  [FunKey.new_user]: 3,
  [FunKey.new_user_gp]: 2,
  [FunKey.new_user_ls]: 1,
}
// 游戏中心主页面 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164408990
export const game_center_homepage = createAsyncThunk(
  'Animal_Lynx/game_center_homepage',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/game/game_center_homepage',
      {...arg},
      {store, xcErrorToast: true}
    )

    return resp.data.data
  }
)

// 弹窗回调 /live/game/game_center_popup_cb http://wiki.xunlei.cn/pages/viewpage.action?pageId=164416186
export const game_center_popup_cb = createAsyncThunk(
  'Animal_Lynx/game_center_popup_cb',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/game/game_center_popup_cb',
      {...arg},
      {store, xcErrorToast: true}
    )

    return resp.data.data
  }
)

export const newUerKeys = [
  FunKey.new_user,
  FunKey.new_user_ls,
  FunKey.new_user_gp,
]

export enum TagEnum {
  new = 1,
  hot,
  popular,
}
export interface FunctionItem {
  func_key: string // 功能key
  name: string // 功能名称
  icon: string // 图标
  link: string // 跳转链接
  bg_color: string
  unread: number // 是否未读（红点）
}

interface BannerItem {
  id: string // 轮播图ID
  name: string // 轮播图名称
  cover: string // 轮播图封面
  link: string // 跳转链接
}

interface StandItem {
  id: string // 轮播图ID
  name: string // 轮播图名称
  cover: string // 轮播图封面
  link: string // 跳转链接
  tag: TagEnum // 标签（1:new/2:hot/3:popular）
}

interface CategorieItem {
  id: string //
  name: string //
  tag: TagEnum // 标签（1:new/2:hot/3:popular）
  stands: StandItem[]
}

export interface PopupItem {
  id: string //
  name: string //
  cover: string //
  link: string // 跳转链接
  time_range: string[] // 开始时间 结束时间
}

interface InitialStateType {
  user_info: {
    mid?: number
    avatar?: string
    name?: string
    coins?: number
    diamonds?: number
  }
  functions: FunctionItem[] // 功能栏
  banners: BannerItem[] // 活动banner
  stands: StandItem[] // 全部游戏位
  categories: CategorieItem[] // 游戏分类
  popups: PopupItem[] // 弹窗列表
}
const initialState: InitialStateType = {
  user_info: {},
  functions: [],
  banners: [],
  stands: [],
  categories: [],
  popups: [],
}

export const Animal_LynxSlice = createSlice({
  name: 'Animal_Lynx',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 首页信息
    builder.addCase(game_center_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default Animal_LynxSlice.reducer
export const useAnimal_LynxState = () => {
  return useSelector((state) => state.Animal_Lynx)
}
export const Animal_LynxActions = Animal_LynxSlice.actions
